export const selectOptions = ['all', 'tattoos', 'artists']
export const searchCategoriesMap = new Map()
searchCategoriesMap.set('all', 'all')
searchCategoriesMap.set('artists', 'artist')
searchCategoriesMap.set('tattoos', 'tattoo')
